import './src/styles/global.css'
import React from 'react'
import { StaticLayout } from './src/layouts/StaticLayout'
import { GatsbyBrowser } from 'gatsby'

// Wraps every page in a component
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => {
  return <StaticLayout {...props}>{element}</StaticLayout>
}
